<template>
    <v-dialog
        v-model="modal"
        :fullscreen="$breakpoint.smAndDown"
        max-width="412"
        persistent
        data-cy="authorization-modal"
        @close="modal = false"
    >
        <v-card class="pt-9 pb-10 px-12">
            <v-btn icon="mdi-close" variant="text" size="small" class="close-btn" @click="modal = false" />
            <v-card-title class="text-h5 text-center">
                {{ forgotPasswordStep ? t('forgot_your_password') : `${t('welcome_back')}` }}
            </v-card-title>
            <template v-if="!forgotPasswordStep">
                <v-tabs
                    v-model="selectedTab"
                    align-tabs="center"
                    color="primary"
                    grow
                    data-cy="tabs"
                    class="mb-5 flex-grow-0 flex-md-grow-1"
                >
                    <v-tab v-for="tab in tabs" :key="tab + '-tab'" :data-cy="tab + '-tab'">
                        {{ t(tab) }}
                    </v-tab>
                </v-tabs>
                <v-tabs-window v-model="selectedTab" class="pt-2">
                    <v-tabs-window-item v-if="tabs.includes('sign_in')" value="sign_in">
                        <NewB2cAuthorizationForm
                            @click-forgot-password="forgotPasswordStep = true"
                            @close-modal="modal = false"
                            @auth-success="onAuthB2cSuccess"
                        />
                    </v-tabs-window-item>
                    <v-tabs-window-item v-if="tabs.includes('sign_in_as_b2b')" value="sign_in_as_b2b">
                        <NewB2bAuthorizationForm
                            @click-forgot-password="forgotPasswordStep = true"
                            @close-modal="modal = false"
                            @auth-success="onAuthB2bSuccess"
                        />
                    </v-tabs-window-item>
                </v-tabs-window>
            </template>
            <template v-else>
                <NewForgotPasswordForm
                    :is-b2b="selectedTab === 1"
                    class="pt-5"
                    @switch-to-login="forgotPasswordStep = false"
                />
            </template>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    import NewB2cAuthorizationForm from '~/components/account/forms/NewB2cAuthorizationForm.vue'
    import NewForgotPasswordForm from '~/components/account/forms/NewForgotPasswordForm.vue'
    import NewB2bAuthorizationForm from '~/components/account/forms/NewB2bAuthorizationForm.vue'

    const modal = defineModel<boolean>({
        default: false,
    })

    const emit = defineEmits(['authB2cSuccess', 'authB2bSuccess'])

    const {t} = useI18n()

    const forgotPasswordStep = ref<boolean>(false)
    const tabs = customizationHelpers.authorizationModalTabs
    const selectedTab = ref<number>(0)

    function onAuthB2cSuccess() {
        emit('authB2cSuccess')
    }

    function onAuthB2bSuccess() {
        emit('authB2bSuccess')
    }
</script>

<style lang="scss" scoped>
    .close-btn {
        position: absolute;
        right: 4px;
        top: 4px;
        color: #94a3b3;
        z-index: 99999;
    }
</style>
